import raven from "raven-js";
import localStorage from "./localStorage";

let tags = {};
window._nounConfig = window._nounConfig || {};
if (window._nounConfig.pluginHost) {
    tags = { pluginHost: window._nounConfig.pluginHost };
}

let sentryConfig = {
    debug: window._nounConfig.debugMode,
    environment: window._nounConfig.environment,
    tags: tags,
    release: window._nounConfig.release,
    ignoreErrors: [
        "Cannot read property 'undefined' of undefined",
        "AMCore is not defined"
    ],
    maxMessageLength: 1000,
    whitelistUrls: [
        // eslint-disable-next-line no-useless-escape
        /static\.(test|staging|production)?\.?thenounproject\.com\/assets\/bundles\/[a-z0-9\-]*.js/
    ],
    shouldSendCallback(data) {
        // Log errors for the dev environment, but don't send to Sentry
        if (window._nounConfig.environment === "dev") {
            console.log("Raven error not sent because environment=dev", data);
            return false;
        }
        let ieString;
        let ref;
        ieString = navigator.userAgent.match(/MSIE \d+.0/);
        if (
            ieString &&
            ((ref = ieString[0]) === "MSIE 7.0" ||
                ref === "MSIE 8.0" ||
                ref === "MSIE 9.0")
        ) {
            return false;
        }
        return true;
    }
};

// Let exceptions from webpack files through to Sentry handling code in development
// but stop them from actually being sent in shouldSendCallback
if (process.env.NODE_ENV != "production") {
    sentryConfig.whitelistUrls.push(/webpack/);
}

let Sentry = raven.config(window._nounConfig.sentryDSN, sentryConfig);

let sentryDisabled = localStorage.getItem("DISABLE_JS_SENTRY");

if (!sentryDisabled) {
    Sentry.install();
} else {
    console.warn("Sentry disabled.");
}

// Check error sending to Sentry
window._errorCheck = function() {
    Sentry.captureException(new Error("It worked!"));
    return true;
};

export default Sentry;
